import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const settingsSearchSchema = z.object({
  tab: z
    .enum([
      'profile',
      'password',
      'api-keys',
      'model-routing',
      'sessions',
      'danger-zone',
    ])
    .optional()
    .default('profile'),
})

export const Route = createFileRoute('/dashboard/settings')({
  validateSearch: settingsSearchSchema,
})
